import React from "react";
import HeaderForm from "./HeaderForm";
import CourierInfo from "./CourierInfo";
import DeliveryMethodSelector from "./DeliveryMethodSelector";
import PostOfficeNotification from "./PostOfficeNotification";
import ActionButtons from "./ActionButtons";
import {clsx} from "clsx";

const PostOfficeForm = ({activeTab, onTabChange, onClose, handleConfirm}) => (
    <div className={clsx("w-full space-y-4 text-sm")}>
        <HeaderForm/>
        <CourierInfo/>
        <div className='bg-white p-4 rounded-md'>
            <DeliveryMethodSelector activeTab={activeTab} onTabChange={onTabChange}/>
        </div>
        <PostOfficeNotification/>
        <ActionButtons onClose={onClose} onConfirm={handleConfirm}/>
    </div>
);
export default PostOfficeForm;